var _rect, _circle, _rect2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 141,
    viewBox: "0 0 191 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    y: 1.20801,
    width: 190,
    height: 120,
    rx: 6,
    fill: "#EFEDFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.7057,
    cy: 37.7359,
    r: 15.733,
    fill: "#F7F6FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_760_1644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 191,
    height: 141
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    y: 0.796875,
    width: 190,
    height: 139.44,
    fill: "#F7F6FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_760_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.133 94.4624L149.244 27.7891L77.1678 90.2888L39.8365 53.7832L-22.8047 115.039H102.478L81.4359 94.4624H226.133Z",
    fill: "#F7F6FC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.910156 93.5303H190.91V115.206C190.91 118.52 188.224 121.206 184.91 121.206H6.91016C3.59645 121.206 0.910156 118.52 0.910156 115.206V93.5303Z",
    fill: "#F7F6FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/photoPlaceholder.9e31d529c7ec7a3ddfaa8f252e6f09f7.svg";
export { ForwardRef as ReactComponent };